import { render, staticRenderFns } from "./SiderRouteExperiences.vue?vue&type=template&id=bed04dba&scoped=true&"
import script from "./SiderRouteExperiences.vue?vue&type=script&lang=js&"
export * from "./SiderRouteExperiences.vue?vue&type=script&lang=js&"
import style0 from "./SiderRouteExperiences.vue?vue&type=style&index=0&id=bed04dba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed04dba",
  null
  
)

export default component.exports